<div class="container landingPage" *ngIf="page$ | async as page">
  <div class="embed-back">
    <button class="btn btn-link" (click)="viewingEmbed = false" [hidden]="!viewingEmbed">Back</button>
    <button class="btn btn-link" (click)="back()" [hidden]="!(page.back_button && !viewingEmbed)">Back</button>
  </div>

  <div [hidden]="!viewingEmbed" id="embed" height="900" width="580px"></div>

  <div class="our-embed" [hidden]="viewingEmbed">
    <h3 class="heading">
      {{ page.title ? page.label : 'Please select a meeting type' }}
    </h3>

    <div class="list-container">
      <div *ngFor="let item of page.items; let i = index" (click)="go(item)">
        <h4 class="title">
          {{ item.title }}
        </h4>
        <h5 class="duration" *ngIf="item.duration">
          Duration:
          <strong>
            {{ item.duration }}
          </strong>
        </h5>
        <p class="description">
          {{ item.people }}
          <br *ngIf="item.people && item.people.length" />
          {{ item.description }}
        </p>

        <div class="arrow">
          <i class="fas fa-chevron-right"></i>
        </div>
      </div>
    </div>
  </div>
</div>
